import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";

// --- Globaler 401-Handler (2026-08-17) -------------------------------------
//
// Vorher: ein abgelaufener Admin-Token (Laufzeit 5h) blieb im localStorage
// liegen. AdminLayout prueft nur, OB ein Token da ist, nie ob er gilt — die
// Oberflaeche sah also eingeloggt aus, waehrend jeder geschuetzte Request
// 401 kassierte. Die Views fingen das still im catch ab und rendertern ihren
// Leerzustand: "Noch keine Bestellungen" bei 4 verkauften Tickets.
//
// WICHTIG: Es gibt zwei unabhaengige Tokens in dieser App —
//   'token'         = Admin/CMS
//   'booking_token' = Endkunden (Ticketshop, Raumbuchung, /mein-bereich)
// Ein 401 aus der Kundenstrecke darf NICHT den Admin ausloggen. Deshalb
// greift der Handler ausschliesslich, wenn der fehlgeschlagene Request
// nachweislich den Admin-Token getragen hat.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const adminToken = localStorage.getItem("token");
      // axios 1.x kapselt Header in AxiosHeaders — .get() ist der
      // zuverlaessige Zugriff, die Property-Varianten sind der Fallback.
      const headers = error.config?.headers;
      const sentAuth =
        (typeof headers?.get === "function" ? headers.get("Authorization") : null) ||
        headers?.Authorization ||
        headers?.authorization ||
        "";

      if (adminToken && sentAuth === `Bearer ${adminToken}`) {
        localStorage.removeItem("token");
        // Kein navigate() moeglich — wir sind ausserhalb des Routers.
        // Guard gegen Redirect-Schleife, falls der Login selbst 401 liefert.
        if (!window.location.pathname.startsWith("/admin/login")) {
          window.location.replace("/admin/login?session=expired");
        }
      }
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
